const actions = {

    // AJAX HANDLING
    async AJAX_SEND({rootState}, body) {
        try {

            var params = {
                route  :  body.route,
                method :  body.method,
            }
            if (body.token !== 'public') {
                params.headers = {'Authorization': `Bearer ${body.token}`}
            }

            if (body.data) {
                params['body'] = body.data
            }

            const data = await rootState.$ajax(params);
            if (data.result) {
                return data
            } else {
                console.log(data)
            }

        } catch (e) {
            console.log(e)
            return e.error
        }
    },

    async GET_GOOGLE_LOCATIONS({dispatch,rootState}) {
        return await dispatch('AJAX_SEND',
            {
                token:rootState.auth.accessToken,
                route:`${rootState.business.selectedBusiness.alias}/googleMaps`,
                method:'GET',
            });
    },
    async EDIT_GOOGLE_LOCATIONS({dispatch,rootState},body) {
        return await dispatch('AJAX_SEND',
            {
                token:rootState.auth.accessToken,
                route:`${rootState.business.selectedBusiness.alias}/googleMaps`,
                method:'POST',
                data : { data : body }
            });
    },





}

export default {
    namespaced:true,
    actions,
}